<div class="container_secondary_action">
<button
  class="btn-secondary export_button"
  valgButton
  color="nav-solid"
  (click)="onClick()">
    <mat-icon class="export_button__icon" [svgIcon]="exportButtonIcon ?? SvgIcon.Download"></mat-icon>
    <span class="text text--normal export_button__text">{{ (buttonText ?? 'table.export_list') | translate }}</span>
  </button>

</div>
